import ankur from "../assets/images/ankur.png";
import anuj from "../assets/images/anuj.png";
import parul from "../assets/images/parul.png";
import amita from "../assets/images/amita.png";
import yogesh from "../assets/images/yogesh.png";
import daulat from "../assets/images/daulat.png";
import deepak from "../assets/images/deepak.png";
import pankaj from "../assets/images/pankaj.png";
import ThemeIcon from "../assets/background-theme-icon.svg";
import BackgroundIcon from "../assets/icon-background.svg";
import textToolIcon from "../assets/text_tool.svg";
import speechIcon from "../assets/icon-microphone.svg";
import clipartToolIcon from "../assets/clipart_tool.svg";
import uploadImageIcon from "../assets/upload-image-icon.svg";

export const teamMembers = [
    {
      name: "Ankur Gupta",
      designation: "Director",
      image: ankur,
      details: {
        industry: [
          "Branding, Sales",
          "Growth",
          "Strategy",
          "Market",
          "Influence",
          "Revenue",
          "Advertising",
          "Networking",
          "Customer Acquisition",
        ],
        personal: [
          "Persuasive",
          "Visionary",
          "Strategic",
          "Energetic",
          "Goal-driven",
          "Motivational",
          "Adaptable",
          "Outgoing",
          "Dynamic",
        ],
      },
    },
    {
      name: "Deepak Garg",
      designation: "Director",
      image: deepak,
      details: {
        industry: [
          "Software Development",
          "AI & Automation",
          "Cybersecurity",
          "Cloud Computing",
          "Data Analytics",
          "System Architecture",
          "Scalability & Performance",
          "Product Innovation",
          "Tech Strategy",
        ],
        personal: [
          "Analytical",
          "Problem-solver",
          "Innovative",
          "Logical",
          "Detail-oriented",
          "Resilient",
          "Tech-savvy",
          "Strategic",
          "Adaptive",
          "Visionary",
        ],
      },
    },
    {
      name: "Amita Wadhwani",
      designation: "GM- Marketing",
      image: amita,
      details: {
        industry: [
          "Brand Strategy",
          "Digital Marketing",
          "Content Marketing",
          "Social Media Management",
          "Campaign Planning",
          "Market Research",
          "SEO & SEM",
          "Customer Engagement",
          "Performance Analytics",
        ],
        personal: [
          "Book Reading",
          "Meditation",
          "Exercise",
          "Reeling",
          "Networking",
          "Public Speaking",
          "Traveling",
          "Blogging",
          "Photography",
          "Music",
          "Copywriting",
        ],
      },
    },
    {
      name: "Daulat Singh",
      designation: "Video Editor",
      image: daulat,
      details: {
        industry: [
          "Editing",
          "Storytelling",
          "Transitions",
          "Motion",
          "Effects",
          "Color-grading",
          "Sound",
          "Composition",
          "Production",
        ],
        personal: [
          "Creative",
          "Detail-oriented",
          "Perceptive",
          "Storyteller",
          "Expressive",
          "Innovative",
          "Patient",
          "Observant",
          "Adaptive",
        ],
      },
    },
    {
      name: "Pankaj Sharma",
      designation: "Graphic Designer",
      image: pankaj,
      details: {
        industry: [
          "Typesetting",
          "Page Layout",
          "Cover Design",
          "Print Production",
          "Proofing",
          "E-book Formatting",
          "Typography Selection",
          "Color Correction",
          "Vector Graphics",
          "Image Editing",
        ],
        personal: [
          "Family time",
          "Playing with kids",
          "Health care",
          "Movies",
          "Music",
          "Cooking",
          "Travel",
          "Gardening",
          "Board games",
          "Photography",
        ],
      },
    },
    {
      name: "Parul Rana",
      designation: "Marketing Executive",
      image: parul,
      details: {
        industry: [
          "Branding",
          "Outreach",
          "Digital",
          "Engagement",
          "Strategy",
          "WhatsApp Advertising",
          "Social Media",
          "Campaigns",
          "Podcasting",
        ],
        personal: [
          "Persuasive",
          "Outgoing",
          "Strategic",
          "Passionate",
          "Creative",
          "Adaptable",
          "Data-driven",
          "Goal-oriented",
          "Visionary",
        ],
      },
    },
    {
      name: "Anuj Chauhan",
      image: anuj,
      designation: "Telesales cum Account Executive",
      details: {
        industry: [
          "Customer Interaction",
          "Lead Generation",
          "Follow-ups",
          "CRM Management",
          "Order Processing",
          "Data Entry",
          "Problem Solving",
          "Target Achievement",
          "Coordination",
        ],
        personal: [
          "Friendly",
          "Talkative",
          "Multitasker",
          "Adaptable",
          "Team Player",
          "Coffee Lover",
          "Social Media Scroller",
          "Quick Learner",
        ],
      },
    },
    {
      name: "Yogesh Dhengale",
      designation: "Software Engineer",
      image: yogesh,
      details: {
        industry: [
          "Software Development",
          "System Architecture",
          "API Integration",
          "UX Design",
          "Scalability & Performance",
          "Project Management",
          "Testing",
          "Maintenance",
          "Debugging",
        ],
        personal: [
          "Tech enthusiast",
          "Tech-savvy",
          "Creative soul",
          "Traveler",
          "Beach + Mountain person",
          "Family man"
        ],
      },
    },
  ];


  export const features = [
    {
      title: "Designs: Templates to Inspire You",
      img: ThemeIcon,
      content: [
        "Choose from a myriad of book templates to start your story.",
        "Get creative ideas and make storytelling easy with ready-made designs.",
        "Pick a theme that matches your story and start writing.",
        "Turn your ideas into a great book with simple and fun design options."
      ]
    },
    {
      title: "Backgrounds: Make your story writing easier to read",
      img: BackgroundIcon,
      content: [
        "Choose from solid backgrounds perfect for book writing and storytelling.",
        "Tailor the background to fit your story writing style with easy adjustments.",
        "Plain backgrounds highlight your storytelling, keeping the focus on your content.",
        "Ideal for any book genre, offering the best templates to write your book."
      ]
    },
    {
      title: "Textbox: Design your words with endless possibilities!",
      img: textToolIcon,
      content: [
        "Write in Hindi or English.",
        "Choose from various fonts and apply bold, italics, or underline styles.",
        "Align text left, center, or right with adjustable letter and line spacing.",
        "Select different colors for your content."
      ]
    },
    {
      title: "Speech to Text: Your Voice, Your Words.",
      img: speechIcon,
      content: [
        "No need to type out every word. Speak your thoughts, and watch them turn into text.",
        "Just click the speaker button and start speaking—let the tool handle the writing for you!",
        "Skip the typing! Record your ideas while the tool does the writing for you."
      ]
    },
    {
      title: "Images: Bring Your Story to Life",
      img: clipartToolIcon,
      content: [
        "Adding images from our collection can make your story visually captivating, helping readers connect with your words even more!",
        "Use images to spark new ideas and give your story an extra depth, transforming your imagination into something unforgettable.",
        "No need to search the web—our in-built images are ready to use instantly, helping you stay focused on what matters most—your storytelling!"
      ]
    },
    {
      title: "Upload Pictures: Your story, even more amazing!",
      img: uploadImageIcon,
      content: [
        "Upload your images to make your book more vibrant and engaging.",
        "Show your creativity by adding your artwork or personal photos to your book.",
        "Visuals make your book unique and help it shine in a crowded world of stories.",
        "A book with pictures catches the eye and keeps readers hooked!"
      ]
    }
  ];
  